<template>
  <div class="lxn-w100 lxn-h100">
    <div class="TvRemoteControllerSlim1-wrapper-remote lxn-margin-auto lxn-pos-rel lxn-h100">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 335 275" style="enable-background:new 0 0 335 275;" xml:space="preserve" class="TvRemoteControllerSlim1-svg lxn-pos-abs lxn-w100">
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#333333;" d="M72.9-0.2h187.7c20.9,0,34.3,5.4,38.1,12.2
          c53.7,97.6,40.7,195.3,0,248.2c-15.1,19.6-247.4,19.5-263.6-0.1c-40.7-48.7-53.7-150.5,0-248.1C38.6,5.4,52-0.2,72.9-0.2L72.9-0.2z"
          />
        <path style="fill:#1D71AA;" d="M89.3,254.4H72.8c-14.4,0-26.1-11.7-26.1-26.1V110.4c0-14.4,11.7-26.1,26.1-26.1h16.5
          c14.4,0,26.1,11.7,26.1,26.1v117.8C115.5,242.6,103.9,254.4,89.3,254.4z"/>
        <polygon style="fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;" points="65.1,177.8 98.5,177.8 98.5,160.4 "/>
        <path style="fill:#079950;" d="M264.1,254.9h-16.5c-14.4,0-26.1-11.7-26.1-26.1V109.2c0-14.4,11.7-26.1,26.1-26.1h16.5
          c14.4,0,26.1,11.7,26.1,26.1v119.6C290.2,243.3,278.5,254.9,264.1,254.9z"/>
        <g>
          <g style="enable-background:new    ;">
            <path style="fill:#FFFFFF;" d="M246.3,184.7V149h13.5c2.4,0,4.2,0.1,5.4,0.3c1.8,0.3,3.2,0.9,4.4,1.7c1.2,0.8,2.1,2,2.9,3.4
              c0.7,1.5,1.1,3.1,1.1,4.9c0,3-1,5.6-2.9,7.7s-5.4,3.1-10.5,3.1h-9.1v14.5L246.3,184.7L246.3,184.7z M251,166h9.2
              c3,0,5.2-0.6,6.5-1.7c1.3-1.1,1.9-2.7,1.9-4.8c0-1.5-0.4-2.8-1.1-3.8s-1.8-1.8-3-2.1c-0.8-0.2-2.3-0.3-4.4-0.3H251V166z"/>
          </g>
        </g>
        <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_POWER')">
          <g>
            <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#FF6666;" d="M83.7,10.1c18.2,0,32.9,14.7,32.9,32.9s-14.9,33.1-32.9,33.1
              c-18.2,0-32.9-14.7-32.9-33.1C50.8,24.8,65.5,10.1,83.7,10.1L83.7,10.1z"/>
          </g>
          <g>
            <g>
              <path style="fill:#FFFFFF;" d="M77.1,30.3c0.9,0,1.8,0.5,2.2,1.3c0.7,1.2,0.3,2.8-0.9,3.5c-3.2,1.9-5.3,5.4-5.3,9.1
                c0,5.8,4.7,10.6,10.6,10.6s10.6-4.7,10.6-10.6c0-3.7-1.8-7-4.9-8.9c-1.2-0.8-1.6-2.4-0.8-3.6c0.8-1.2,2.4-1.6,3.6-0.8
                c4.6,2.9,7.3,7.9,7.3,13.3c0,8.7-7.1,15.7-15.8,15.7s-15.8-7.1-15.8-15.8c0-5.6,3-10.8,7.8-13.6C76.2,30.4,76.7,30.3,77.1,30.3z"
                />
            </g>
            <g>
              <path style="fill:#FFFFFF;" d="M83.7,26.2c1.4,0,2.6,1.2,2.6,2.6v11.9c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6V28.8
                C81.2,27.4,82.3,26.2,83.7,26.2z"/>
            </g>
          </g>
        </g>
        <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_SOURCE')">
          <path style="fill:#666666;" d="M258.2,62h-64.3c-3.8,0-6.8-3-6.8-6.8V35.6c0-3.8,3-6.8,6.8-6.8h64.3c3.8,0,6.8,3,6.8,6.8v19.6
            C264.9,59,261.9,62,258.2,62z"/>
          <g>
            <path style="fill:#FFFFFF;" d="M201.3,49.3c0.7,0.4,1.8,0.8,2.8,0.8c1.6,0,2.6-0.9,2.6-2.1c0-1.2-0.7-1.8-2.3-2.4
              c-2-0.7-3.2-1.8-3.2-3.5c0-1.9,1.6-3.3,4-3.3c1.3,0,2.2,0.3,2.7,0.6l-0.4,1.3c-0.4-0.2-1.2-0.6-2.3-0.6c-1.7,0-2.3,1-2.3,1.8
              c0,1.2,0.8,1.7,2.4,2.4c2.1,0.8,3.1,1.8,3.1,3.6c0,1.9-1.4,3.5-4.3,3.5c-1.2,0-2.5-0.3-3.1-0.8L201.3,49.3z"/>
            <path style="fill:#FFFFFF;" d="M218.5,46.8c0,3.3-2.3,4.7-4.4,4.7c-2.4,0-4.2-1.8-4.2-4.5c0-3,1.9-4.7,4.4-4.7
              C216.8,42.2,218.5,44.1,218.5,46.8z M211.5,46.9c0,1.9,1.1,3.4,2.7,3.4c1.5,0,2.7-1.4,2.7-3.4c0-1.5-0.8-3.4-2.6-3.4
              C212.4,43.4,211.5,45.2,211.5,46.9z"/>
            <path style="fill:#FFFFFF;" d="M227.9,48.8c0,0.9,0,1.7,0.1,2.4h-1.4l-0.1-1.4l0,0c-0.4,0.7-1.4,1.6-2.9,1.6c-1.4,0-3-0.8-3-3.9
              v-5.2h1.6v4.9c0,1.7,0.5,2.8,2,2.8c1.1,0,1.8-0.8,2.1-1.5c0.1-0.2,0.1-0.5,0.1-0.8v-5.4h1.6L227.9,48.8L227.9,48.8z"/>
            <path style="fill:#FFFFFF;" d="M230.6,45.2c0-1,0-1.9-0.1-2.8h1.4l0.1,1.7h0.1c0.4-1.2,1.4-1.9,2.4-1.9c0.2,0,0.3,0,0.5,0v1.6
              c-0.2,0-0.3,0-0.6,0c-1.1,0-1.9,0.9-2.1,2.1c0,0.2-0.1,0.5-0.1,0.8v4.7h-1.6L230.6,45.2L230.6,45.2z"/>
            <path style="fill:#FFFFFF;" d="M242.6,50.9c-0.4,0.2-1.4,0.5-2.5,0.5c-2.7,0-4.4-1.8-4.4-4.5s1.9-4.7,4.7-4.7
              c0.9,0,1.8,0.2,2.2,0.5l-0.4,1.2c-0.4-0.2-1-0.4-1.9-0.4c-2,0-3.1,1.5-3.1,3.3c0,2,1.3,3.3,3.1,3.3c0.9,0,1.5-0.2,2-0.4
              L242.6,50.9z"/>
            <path style="fill:#FFFFFF;" d="M245.3,47.1c0,2.2,1.4,3.1,3,3.1c1.1,0,1.8-0.2,2.4-0.5l0.3,1.2c-0.6,0.2-1.5,0.5-2.9,0.5
              c-2.7,0-4.3-1.8-4.3-4.4s1.6-4.8,4.1-4.8c2.9,0,3.6,2.5,3.6,4.2c0,0.3,0,0.6-0.1,0.8L245.3,47.1L245.3,47.1z M250,46
              c0-1-0.4-2.6-2.2-2.6c-1.6,0-2.3,1.5-2.5,2.6H250z"/>
          </g>
        </g>
        <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_MUTE')">
          <path style="fill:#666666;" d="M178.2,229.1h-21c-5.5,0-10-4.5-10-10v-21c0-5.5,4.5-10,10-10h21c5.5,0,10,4.5,10,10v21
            C188.2,224.6,183.7,229.1,178.2,229.1z"/>
          <g>
            <g>
              <path style="fill:#FFFFFF;" d="M168.5,212.3l2.7-4l-2.3-3.5c-0.2-0.3-0.4-0.6-0.5-0.9c-0.1-0.2-0.2-0.5-0.2-0.7s0.1-0.4,0.3-0.6
                c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3s0.5,0.6,0.8,1.1l1.8,3l1.9-3c0.2-0.2,0.3-0.5,0.4-0.6s0.2-0.3,0.3-0.4s0.2-0.2,0.4-0.3
                s0.3-0.1,0.4-0.1c0.3,0,0.6,0.1,0.8,0.3s0.3,0.4,0.3,0.7c0,0.4-0.2,0.9-0.6,1.5l-2.4,3.6l2.6,4c0.2,0.4,0.4,0.6,0.5,0.9
                c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.1,0.5s-0.2,0.3-0.4,0.4c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4-0.1-0.6-0.1
                c-0.2-0.1-0.3-0.2-0.4-0.4s-0.3-0.4-0.6-0.8l-2.1-3.4l-2.3,3.5c-0.2,0.3-0.3,0.5-0.4,0.6c-0.1,0.1-0.2,0.2-0.3,0.3
                s-0.2,0.2-0.4,0.2s-0.3,0.1-0.5,0.1c-0.3,0-0.6-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.8C167.9,213.4,168.1,212.9,168.5,212.3z"/>
            </g>
            <rect x="158.2" y="205.1" style="fill:#FFFFFF;" width="2.6" height="7"/>
            <polygon style="fill:#FFFFFF;" points="167.2,215.2 160.7,212.1 160.7,205.1 167.2,202 		"/>
          </g>
        </g>
        <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_CHANNELUP')" style="fill:#079950;" d="M289.9,134.8h-68.2v-24.3c0-14.9,12.1-27,27-27h14.2c14.9,0,27,12.1,27,27V134.8z"/>
        <polyline class="lxn-cursor-pointer" @click="buttonClicked('KEY_CHANNELUP')" style="fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;" points="244.1,109.2 254.7,96.3 265,109.2 "/>
        <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_CHANNELDOWN')" style="fill:#079950;" d="M265.5,254.6H246c-13.4,0-24.3-10.9-24.3-24.3v-27h68.2v27C289.9,243.7,279,254.6,265.5,254.6z"/>
        <polyline class="lxn-cursor-pointer" @click="buttonClicked('KEY_CHANNELDOWN')" style="fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;" points="265,227 254.6,240 244.1,227 "/>
        <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_VOLUMEUP')" style="fill:#1D71AA;" d="M115.2,134.8H47v-24.3c0-14.9,12.1-27,27-27h14.2c14.9,0,27,12.1,27,27V134.8z"/>
        <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_VOLUMEDOWN')" style="fill:#1D71AA;" d="M90.8,253.6H71.3c-13.4,0-24.3-10.9-24.3-24.3v-27h68.2v27C115.2,242.7,104.3,253.6,90.8,253.6z"/>
        <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_VOLUMEUP')" style="fill:#FFFFFF;" d="M84.5,95.5v12h11.4v5.2H84.5v12.1h-5.4v-12.2H67.6v-5.2H79v-12L84.5,95.5L84.5,95.5z"/>
        <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_VOLUMEDOWN')" style="fill:#FFFFFF;" d="M92.5,229.7v5.5H71.3v-5.5H92.5L92.5,229.7z"/>
        <g class="lxn-cursor-pointer" @click="openRemote()">
          <path style="fill:#666666;" d="M179,145.3h-21c-5.5,0-10-4.5-10-10v-21c0-5.5,4.5-10,10-10h21c5.5,0,10,4.5,10,10v21
            C189,140.8,184.6,145.3,179,145.3z"/>
          <path style="fill:#FFFFFF;" d="M165.7,121.8h1.3c0.2-0.6,0.7-1,1.3-1.3v-1.3C167,119.6,166,120.5,165.7,121.8L165.7,121.8z
            M169,122c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6l0,0c0.3,0,0.6-0.3,0.6-0.6S169.4,122,169,122z"/>
          <path style="fill:#FFFFFF;" d="M167,123.4h-1.3c0.3,1.2,1.3,2.2,2.5,2.5v-1.3C167.7,124.4,167.2,124,167,123.4L167,123.4z
            M169.9,119.3v1.3c0.6,0.2,1,0.7,1.3,1.3h1.3C172.1,120.5,171.1,119.6,169.9,119.3z M179.7,118.8l-6.8-6.8
            c-0.6-0.6-1.3-0.9-2.2-0.9c-0.9,0-1.6,0.3-2.2,0.9l-13.4,13.4c-3.1,3.1-3.1,8.1,0,11.2c1.5,1.5,3.5,2.3,5.6,2.3
            c2.1,0,4.1-0.8,5.6-2.3l13.4-13.4C180.9,121.9,180.9,120,179.7,118.8L179.7,118.8z M171.1,115.4c0.2-0.2,0.4-0.2,0.6-0.2
            c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2s-0.4-0.1-0.6-0.2
            c-0.2-0.2-0.2-0.4-0.2-0.6S171,115.5,171.1,115.4L171.1,115.4z M163.5,127c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2
            c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2s-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6
            C163.2,127.4,163.3,127.2,163.5,127L163.5,127z M160.8,124.4c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6
            c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6S160.6,124.5,160.8,124.4L160.8,124.4z M158.8,126.4
            c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2
            c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6C158.6,126.7,158.6,126.5,158.8,126.4z M156.6,128.9c0-0.2,0.1-0.4,0.2-0.6
            c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.4-0.1-0.6-0.2
            C156.6,129.4,156.6,129.2,156.6,128.9L156.6,128.9z M158.6,134.2c-0.2,0.2-0.4,0.2-0.6,0.2s-0.4-0.1-0.6-0.2
            c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6
            C158.9,133.8,158.8,134,158.6,134.2L158.6,134.2z M160.6,132.2c-0.2,0.2-0.4,0.2-0.6,0.2s-0.4-0.1-0.6-0.2
            c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6
            C160.9,131.8,160.8,132,160.6,132.2L160.6,132.2z M161.2,129.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2
            c0.2,0.2,0.2,0.4,0.2,0.6c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.4-0.1-0.6-0.2C161.3,130,161.2,129.8,161.2,129.6L161.2,129.6z
            M163.3,134.9c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2
            s0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6S163.4,134.7,163.3,134.9L163.3,134.9z M165.3,132.9c-0.2,0.2-0.4,0.2-0.6,0.2
            s-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6
            S165.4,132.7,165.3,132.9L165.3,132.9z M167.3,130.8c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.3-0.3-0.8,0-1.2
            c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6C167.5,130.5,167.4,130.7,167.3,130.8L167.3,130.8z M169,127.7
            c-2.8,0-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1c2.8,0,5.1,2.3,5.1,5.1S171.8,127.7,169,127.7z M176.3,120.5c-0.3,0.3-0.8,0.3-1.2,0
            c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6
            S176.4,120.4,176.3,120.5L176.3,120.5z M169.9,124.7v1.3c1.2-0.3,2.2-1.3,2.5-2.5h-1.3C170.9,124,170.4,124.4,169.9,124.7
            L169.9,124.7z"/>
        </g>
        </svg>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'

export default {
  name: 'TvRemoteControllerSlim1',
  props: {
    nodeUUID: Number,
    outputIndex: Number,
    sendCommand: Boolean,
  },
  data: function() {
    return {
      node: this.$store.getters.getNodeByUUID(this.nodeUUID),
      targetCommandIndex: -1,
      commandSetTimeoutHandle: -1,
      debounceDelay: 0,
    }
  },
  components: {
    ButtonIcon
  },
  mounted: function () {
  },
  watch: {
    nodeUUID: function (newVal) {
      this.node =this.$store.getters.getNodeByUUID(newVal);
    },
    targetCommandIndex: function (newVal) {
      if(newVal == -1){
        return;
      }
      if(this.sendCommand){
        clearTimeout(this.commandSetTimeoutHandle);
        this.commandSetTimeoutHandle = setTimeout(function () {
          this.$store.commit('setAppBusy', true);
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          this.$store.dispatch('setNodesParameters', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
            bodyContent: {
              nodeActions: [
                {
                  nodeUUID: this.node.uuid,
                  actions: [
                    {
                      parameterId: NODE7.IR.PARAMETER_ID,
                      valueOfChange: messagingHook.utility.arrayTo128(this.irDevice.commands[newVal].command),
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    }
                  ]
                },
              ]
            }
          })
          .then( () => {
            console.log("Done");
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode == 1){
              this.$router.push('/SettingsNodeError');
            }else if(response.rejectCode == 2){
              this.$router.push('/SettingsHubError');
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            this.$store.commit('setAppBusy', false);
          })
          .finally( () => {
            this.targetCommandIndex = -1;
          })
        }.bind(this), this.debounceDelay);
      }
    },
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    output: function () {
      return this.node.outputs[this.outputIndex];
    },
    irDevice: function () {
      var irDevice = NODE7.devices[this.output.settings.deviceType].brands[this.output.settings.brand].devices[this.output.settings.model];
      return irDevice;
    },
  },
  methods: {
    buttonClicked: function (button) {
      if(this.sendCommand){
        var commandIndex = this.irDevice.commands.findIndex( command => command.function == button);
        if(commandIndex != -1){
          this.targetCommandIndex = commandIndex;
        }
      }
    },
    openRemote: function () {
      if(this.sendCommand){
        this.$router.push('/showIrRemote/' + this.nodeUUID + '/' + this.outputIndex);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .TvRemoteControllerSlim1-wrapper-remote {
    width: 90%;
  }
  .TvRemoteControllerSlim1-svg {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
